import React from 'react';
import styled from 'styled-components';

import { Animation } from 'components'

const Container2 = styled.div`
    position: absolute;
    z-index: 1300;
    padding: 2rem 2rem 2rem 2rem;
    border-radius: 5px;
    width: 30rem;
    height: 90vh;
    overflow-y: hidden;
    overflow-x: hidden;
    background: var(--primary-color);
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    border-radius: 5px;
    box-shadow: 0px 2px 1px -1px var(--primary-accent2-color), 
                0px 1px 1px 0px var(--primary-accent2-color),
                0px 1px 3px 0px var(--primary-accent2-color);
    @media (max-width: 600px) {
        width: 80vw;
    }
`

const Container = styled.div`
    width: 100%;
    min-height: 100vh;
    border: 1px solid white;
    box-sizing: border-box;
`

const ListTab = props => {

    return (
        <Container>
            List
        </Container>
    )
}

export default ListTab